//  export const  questions = [
//       {
//         "question": "What is the most common congenital male reproductive disorder?",
//         "options": ["Hydrocoele", "Peyronie's disease", "Cryptorchidism", "Testicular torison"],
//         "correctOption": 1,
//         "points": 10
//       },
//       {
//         "question": "What is the causative agent of condyloma acuminatum?",
//         "options": ["HPV 6 or 11", "HSV", "E coli", "Chlamydia trachomatics"],
//         "correctOption": 3,
//         "points": 10
//       },
//       {
//         "question": "What is the risk factors for developing germ cell tumours?",
//         "options": ["Orchitis", "Hypospadias and epispadias", "Klinefelter syndrome and Cryptorchidism", "Hydrocoele and varicocele"],
//         "correctOption": 0,
//         "points": 10
//       },
//       {
//         "question": "What area does prostate cancer spread to most frequently?",
//         "options": ["Pancreas", "Lung", "Lumbar spine", "Brain"],
//         "correctOption": 2,
//         "points": 10
//       },
//       {
//         "question": "How does testicular torison typically present?",
//         "options": [
//           "Sudden pain in the scrotum and an absent  cremasteric reflex",
//           "Swelling of the  scrotum and fever",
//           "A painful testicular mass that cannot be transilluminated",
//           "'Bag of worms' appearence of scortum"
//         ],
//         "correctOption": 0,
//         "points": 10
//       },
//       {
//         "question": "what is priaprism?",
//         "options": ["painful erection lasting > 4 hours", "Abnormal curvature of the peins", "inability to void the bladder", "Cyst due to  dialted testicular duct"],
//         "correctOption": 1,
//         "points": 10
//       },
//       {
//         "question": "Are testicular tumours usually biopsied",
//         "options": [
//           "No",
//           "Yes"
//         ],
//         "correctOption": 1,
//         "points": 30
//       },
//       {
//         "question": "What triggers a UI re-render in React?",
//         "options": [
//           "Running an effect",
//           "Passing props",
//           "Updating state",
//           "Adding event listeners to DOM elements"
//         ],
//         "correctOption": 2,
//         "points": 20
//       },
//       {
//         "question": "What is the best description for the area of the prostate that the carcinoma usually affects?",
//         "options": [
//           "Periurethral region",
//           "Anterior and peripheral region",
//           "entire anterior region",
//           "Posterior and peripheral region"
//         ],
//         "correctOption": 3,
//         "points": 20
//       },
//       {
//         "question": "What tumour is characterisec by finding of 'Schiller Duval bodies' on histology amd raised level of AFP on blod tests?",
//         "options": [
//           "Sertoli cell tumour",
//           "Teratoma",
//           "Yolk sac tumour",
//           "Embryonel carcinoma"
//         ],
//         "correctOption": 3,
//         "points": 30
//       },
//       {
//         "question": "What is the grading system for  prostatic cancer?",
//         "options": [
//           "Breslow thickness",
//           "Gleason",
//           "Fuhrman",
//           "Bloom Richardson"
//         ],
//         "correctOption": 2,
//         "points": 30
//       },
//       {
//         "question": "What is hypospadisa?",
//         "options": ["Opening of urethra on dorsal surface of the peins", "Benign warty growth on genital skin", "Opening of urethra on the vental surface of the peins", "inflammation of the testicles"],
//         "correctOption": 1,
//         "points": 10
//       }
//     ]

export const questions = [
  {
    question_id: "160",
    question_text: "She is …………. beautiful girl in the class.",
    question_image: "",
    question_answers: "a) many//CAMP//b) more//CAMP//c) much",
    question_valid_answer: "b) more",
    course_id: "1",
    unit_id: "166",
    video_id: null,
    type: "mcq",
    gameType: "character",
    real_answers: [
      {
        answer_text: "a) many",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "b) more",
        answer_exp: "",
        answer_check: true,
      },
      {
        answer_text: "c) much",
        answer_exp: "",
        answer_check: false,
      },
    ],
  },
  {
    question_id: "161",
    question_text: "How…………. do you go to the club?",
    question_image: "",
    question_answers:
      "a) Never//CAMP//b) Always//CAMP//c) Often//CAMP//d) Sometimes",
    question_valid_answer: "c) Often",
    course_id: "1",
    unit_id: "161",
    video_id: null,
    type: "mcq",
    gameType: "character",
    real_answers: [
      {
        answer_text: "a) Never",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "b) Always",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "c) Often",
        answer_exp: "",
        answer_check: true,
      },
      {
        answer_text: "d) Sometimes",
        answer_exp: "",
        answer_check: false,
      },
    ],
  },
  {
    question_id: "162",
    question_text: "He …………. eats apples. He likes eating them.",
    question_image: "",
    question_answers:
      "a) never//CAMP//b) always//CAMP//c) hardly ever//CAMP//d) hardly",
    question_valid_answer: "b) always",
    course_id: "1",
    unit_id: "161",
    video_id: null,
    type: "mcq",
    gameType: "character",
    real_answers: [
      {
        answer_text: "a) never",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "b) always",
        answer_exp: "",
        answer_check: true,
      },
      {
        answer_text: "c) hardly ever",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "d) hardly",
        answer_exp: "",
        answer_check: false,
      },
    ],
  },
  {
    question_id: "164",
    question_text: "He …….playing tennis.",
    question_image: "",
    question_answers: "a) am//CAMP//b) is//CAMP//c) are//CAMP//d) were",
    question_valid_answer: "b) is",
    course_id: "1",
    unit_id: "163",
    video_id: null,
    type: "mcq",
    gameType: "character",
    real_answers: [
      {
        answer_text: "a) am",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "b) is",
        answer_exp: "",
        answer_check: true,
      },
      {
        answer_text: "c) are",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "d) were",
        answer_exp: "",
        answer_check: false,
      },
    ],
  },
  {
    question_id: "165",
    question_text: "He is ………...",
    question_image: "",
    question_answers:
      "a) sleep//CAMP//b) sleeping//CAMP//c) sleeps//CAMP//d) slept",
    question_valid_answer: "b) sleeping",
    course_id: "1",
    unit_id: "163",
    video_id: null,
    type: "mcq",
    gameType: "character",
    real_answers: [
      {
        answer_text: "a) sleep",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "b) sleeping",
        answer_exp: "",
        answer_check: true,
      },
      {
        answer_text: "c) sleeps",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "d) slept",
        answer_exp: "",
        answer_check: false,
      },
    ],
  },
  {
    question_id: "166",
    question_text: "Are you …..?",
    question_image: "",
    question_answers: "a) come//CAMP//b) comes//CAMP//c) coming",
    question_valid_answer: "c) coming",
    course_id: "1",
    unit_id: "163",
    video_id: null,
    type: "mcq",
    gameType: "character",
    real_answers: [
      {
        answer_text: "a) come",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "b) comes",
        answer_exp: "",
        answer_check: false,
      },
      {
        answer_text: "c) coming",
        answer_exp: "",
        answer_check: true,
      },
    ],
  },
  {
    question_id: "257",
    question_text: "Birds fly in the blue sky",
    question_image: "",
    question_answers: "",
    question_valid_answer: "Birds fly in the blue sky",
    course_id: "1",
    unit_id: "15",
    video_id: null,
    type: "arrangePuzzle",
    gameType: "word",
    correctSentence: "Birds fly in the blue sky",
    str_shuffle: ["blue", "Birds", "sky", "fly", "in", "the"],
  },
  {
    question_id: "258",
    question_text: "world",
    question_image: "",
    question_answers: "",
    question_valid_answer: "world",
    course_id: "1",
    unit_id: "15",
    video_id: null,
    type: "arrangePuzzle",
    gameType: "character",
    correctSentence: "world",
    str_shuffle: ["r", "d", "l", "w", "o"],
  },
  {
    question_id: "259",
    question_text:
      "Python**linematch**0//camp//Apple**linematch**1//camp//Photosynthesis**linematch**2//camp//Jupiter**linematch**3//camp//Shakespeare**linematch**4",
    question_image: "",
    question_answers:
      "Programming Language**linematch**0//camp//Largest Planet**linematch**1//camp//Tech Company**linematch**2//camp//Plant Process**linematch**3//camp//Famous Playwright**linematch**4\n",
    question_valid_answer: "",
    course_id: "1",
    unit_id: "15",
    video_id: null,
    type: "line-match",
    gameType: "character",
    leftColumn: [
      {
        text: "Python",
        type: "0",
      },
      {
        text: "Apple",
        type: "1",
      },
      {
        text: "Photosynthesis",
        type: "2",
      },
      {
        text: "Jupiter",
        type: "3",
      },
      {
        text: "Shakespeare",
        type: "4",
      },
    ],
    rightColumn: [
      {
        text: "Programming Language",
        type: "0",
      },
      {
        text: "Largest Planet",
        type: "1",
      },
      {
        text: "Tech Company",
        type: "2",
      },
      {
        text: "Plant Process",
        type: "3",
      },
      {
        text: "Famous Playwright",
        type: "4",
      },
    ],
  },
];
